// extracted by mini-css-extract-plugin
export var phone = "_48-0";